import { render, staticRenderFns } from "./components.vue?vue&type=template&id=6c1a6137"
import script from "./components.vue?vue&type=script&lang=js"
export * from "./components.vue?vue&type=script&lang=js"
import style0 from "./components.vue?vue&type=style&index=0&id=6c1a6137&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1a6137')) {
      api.createRecord('6c1a6137', component.options)
    } else {
      api.reload('6c1a6137', component.options)
    }
    module.hot.accept("./components.vue?vue&type=template&id=6c1a6137", function () {
      api.rerender('6c1a6137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/tabs/components.vue"
export default component.exports